import { createProtectedContext } from '../../lib/createProtectedContext';
import type { SlotProps } from '../Slot.types';

export type SlotContextData = Pick<SlotProps, 'isDisabled'>;

export const SlotContext = createProtectedContext<SlotContextData>('SlotContext');

export const useSlotContext = SlotContext.useContext;
